import React, { FC, ReactNode } from 'react'
import clsx from 'clsx'

import styles from './_.module.css'

interface Tab {
  title: ReactNode
  value: string
  data_id?: string
  disabled?: boolean
}

interface Props {
  tabList: Tab[]
  activeTab: string
  onTabChange: (tab: string) => void
  className?: string
  containerClassName?: string
  isDisabled?: boolean
}

const SwitchTabs: FC<Props> = ({
  tabList = [],
  activeTab,
  onTabChange,
  className,
  containerClassName,
  isDisabled = false
}) => {
  return (
    <div
      className={clsx(styles.tabContainer, containerClassName, {
        [styles.disabledContainer]: isDisabled
      })}
    >
      {tabList.map((tab: Tab, index: number) => (
        <div
          className={clsx(styles.tab, className, {
            [styles.active]: tab.value === activeTab,
            [styles.disabled]: isDisabled || tab.disabled
          })}
          key={index}
          onClick={() => !tab.disabled && onTabChange(tab.value)}
          onKeyPress={() => !tab.disabled && onTabChange(tab.value)}
          data-id={tab.data_id}
          tabIndex={0}
          role="button"
        >
          {tab.title}
        </div>
      ))}
    </div>
  )
}

export { SwitchTabs }
